import AxiosInstance from '../../../http-config'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux/helpers'
import { EnumCommodity, EnumTipoCalculoConcepto } from '../../..'
import {
  FlexibilityTableModel,
  FlexibilitiesModel,
  QuantityFlexibilityModel,
  PatchPercentageRequest,
  CalculationConceptType,
  GetFlexibilitiesRequest,
  FlexibilitySubtype,
  FlexibilityGroup,
  NewFlexibilityRequest,
  FlexibilityModel,
  FlexibilitySubtypeLimits,
  PatchFlexibilityRequest,
  FlexibilitySubtypeQuantityTypes
} from './model/flexibilities'
import { QuantityFlexibility } from '../../../../pages/flexibility/flexibility.Model'

export const fetchFlexibilities = async ({
  commodity,
  balanceZone,
  company,
  calculationType = null,
  contractCode = null,
  settlementGroupCode = null
}: GetFlexibilitiesRequest): Promise<FlexibilitiesModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  let query = `commodity=${commodity}&balancezone=${balanceZone}&company=${company}`

  if (calculationType) {
    query += `&calculationtype=${calculationType}`
  }

  if (contractCode) {
    query += `&contractcode=${contractCode}`
  }

  if (settlementGroupCode) {
    query += `&settlementgroupcode=${settlementGroupCode}`
  }

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Flexibilities?${query}`).then(response => {
    return response.data
  })
}

export const fetchFlexibilityByID = async (id: number): Promise<FlexibilityModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65521'

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Flexibilities/${id}`).then(response => {
    return response.data
  })
}

export const fetchLimit = async (id: number): Promise<QuantityFlexibility> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65182'

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Flexibilities/${id}/Limits`).then(
    response => {
      return response.data === '' ? {} : response.data
    }
  )
}

export const apiPostFlexibility = async (request: NewFlexibilityRequest): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65521'

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Flexibilities`, request).then(response => {
    return response.data
  })
}

export const apiPatchFlexibility = async (
  flexibilityId: number,
  patchRequest: PatchFlexibilityRequest
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65521'

  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/Flexibilities/${flexibilityId}`,
    patchRequest
  ).then(response => {
    return response.data
  })
}

export const patchFlexibilityLimit = async (
  flexibilityId: number,
  limitId: number,
  patchRequest: PatchPercentageRequest
): Promise<PatchPercentageRequest> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/Flexibilities/${flexibilityId}/Limits(${limitId})`,
    patchRequest
  ).then(response => {
    return response.data
  })
}

export const updateFlexibilityLimits = async (
  flexibilityId: number,
  patchRequest: QuantityFlexibility
): Promise<QuantityFlexibility> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65182'

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Flexibilities/${flexibilityId}/UpdateLimits`,
    patchRequest
  ).then(response => {
    return response.data
  })
}

export const apifetchCalculationConceptTypes = async (): Promise<CalculationConceptType[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Flexibilities/CalculationConceptTypes`).then(
    response => {
      return response.data
    }
  )
}

export const apifetchCalculationConceptTypesForProduct = async (
  productID: number
): Promise<CalculationConceptType[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Flexibilities/CalculationConceptTypesForProduct?productId=${productID}`
  ).then(response => {
    return response.data
  })
}

export const apifetchFlexibilitySubtypesByCalculationTypes = async (
  calculationTypes: EnumTipoCalculoConcepto[]
): Promise<FlexibilitySubtype[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  let query = ''

  calculationTypes.forEach(calculationType => {
    query += `&calculationConceptTypes=${calculationType}`
  })

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Flexibilities/GetFlexibilitySubtypesByCalculationTypes?${query}`
  ).then(response => {
    return response.data
  })
}

export const apifetchFlexibilityGroups = async (): Promise<FlexibilityGroup[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Flexibilities/GetFlexibilityGroups`).then(
    response => {
      return response.data
    }
  )
}

export const apifetchFlexibilitySubtypeLimits = async (): Promise<FlexibilitySubtypeLimits[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65182'

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Flexibilities/FetchSubtypesLimits`).then(
    response => {
      return response.data
    }
  )
}

export const apifetchFlexibilitySubtypesQuantityTypes = async (): Promise<
  FlexibilitySubtypeQuantityTypes[]
> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65182'

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Flexibilities/FetchSubtypesQuantityTypes`
  ).then(response => {
    return response.data
  })

  // return await new Promise((resolve, reject) => {
  //   reject('')
  // })
}

export const apiDeleteFlexibility = async (id: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65182'

  return await AxiosInstance.delete(`${apiSuffixUrl}/api/Flexibilities/${id}`).then(response => {
    return response.data
  })
}
